<template lang="pug">
  .layout
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    v-card-text.pa-0(v-else)

      div.page-break.pa-8(v-for="lead in packListResp.leads" :key="lead.id")
        div.d-flex
          .h5.font-weight-regular.mt-auto {{ packListResp.company.name }}
          v-spacer
          div.text-end
            .p2.basic600--text {{ $t('order_id') }}: &#35;{{ lead.rid }}
            .p2.basic600--text {{ $t('date_ordered') }}: {{ (lead.processed_at || lead.created) | humanizeDate }}
        div.d-flex.mt-4
          .recipient.mr-12(style="max-width: 300px")
            .c2.basic700--text {{ $t('recipient_address') }}
            .address(v-if="lead.shipping_address")
              .c1.basic700--text {{ lead.shipping_address.name ? lead.shipping_address.name : lead.name }}
              .c1.basic700--text {{ lead.shipping_address.address_1 }},
              .c1.basic700--text(v-if="lead.shipping_address.address_2") {{ lead.shipping_address.address_2 }},
              template(v-if="lead.shipping_address.area")
                .c1.basic700--text {{ lead.shipping_address.postcode }} {{ lead.shipping_address.area }},
                .c1.basic700--text {{ lead.shipping_address.suburb }}, {{ lead.shipping_address.city }},
              .c1.basic700--text(v-else) {{ lead.shipping_address.postcode }} {{ lead.shipping_address.city }},
              .c1.basic700--text {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.
              .c1.basic700--text {{ lead.shipping_address.phone ? lead.shipping_address.phone : lead.phone | phoneFormat }}

          .billing.mr-4(style="max-width: 300px")
            .c2.basic700--text {{ $t('billing_address') }}
            .address(v-if="lead.shipping_address")
              .c1.basic700--text {{ lead.name }}
              .c1.basic700--text {{ lead.shipping_address.address_1 }},
              .c1.basic700--text(v-if="lead.shipping_address.address_2") {{ lead.shipping_address.address_2 }},
              template(v-if="lead.shipping_address.area")
                .c1.basic700--text {{ lead.shipping_address.postcode }} {{ lead.shipping_address.area }},
                .c1.basic700--text {{ lead.shipping_address.suburb }}, {{ lead.shipping_address.city }},
              .c1.basic700--text(v-else) {{ lead.shipping_address.postcode }} {{ lead.shipping_address.city }},
              .c1.basic700--text {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.
              .c1.basic700--text {{ lead.phone | phoneFormat }}
        
        .products.mt-3
          .header
            v-row(no-gutters)
              v-col.shrink.py-2
                div(style="width: 80px")
                  div.c2.basic700--text.pl-2 #
              v-col.py-2
                v-row(no-gutters)
                  v-col.pa-0
                    div.c2.basic700--text {{ $t('description') }}
                  v-col.pa-0.shrink
                    div.d-flex.align-center(style="width: 80px;")
                      v-spacer
                      div.c2.basic700--text.mr-2 {{ $t('qty') }}
           
          v-divider.basic600

          .content
            template(v-for="(product, idx) in lead.lead_products" v-if="product.quantity > 0")
              v-row(no-gutters :key="pick+idx")
                v-col.shrink.py-3
                  div.d-flex.align-center.justify-center(style="width: 80px")
                    div.p2.primary500--text.mb-auto {{ idx+1 }}
                    div.ml-3
                      v-img(:src="product.product.image ? `https://img.yezza.io/100x100/${product.product.image.path}` : require('@/assets/image_placeholder.png')" max-width="40px" width="40px" height="40px" eager)

                v-col.py-2
                  v-row(no-gutters)
                    v-col.pa-0
                      div.d-flex.align-center
                        div.mb-auto.pb-2
                          .p2.primary--text {{ product.name }}
                          template(v-for="a in product.addons")
                            div.d-flex.align-center
                              div.c1.basic700--text.mt-2.mb-auto + {{ a.name }} {{ a.quantity_per_set > 1 ? ' x ' + a.quantity_per_set : '' }}
                    v-col.pa-0.shrink
                      div.d-flex.align-center.mr-4(style="width: 80px;")
                        v-spacer
                        div.p2.primary500--text.pl-2 {{ product.quantity }}

          v-divider.basic600.mt-2

        div.text-center.mt-8
          .c1.basic700--text {{ $t('thank_you_for_shopping') }}
          .c2.basic700--text.mt-6 {{ packListResp.company.name }}
          div.p2.primary500--text(v-if="packListResp.company.address")
            div {{ packListResp.company.address.address_1 }},
            div(v-if="packListResp.company.address.address_2") {{ packListResp.company.address.address_2 }},
            template(v-if="packListResp.company.address.area")
              div {{ packListResp.company.address.postcode }} {{ packListResp.company.address.area }},
              div {{ packListResp.company.address.suburb }}, {{ packListResp.company.address.city }},
            div(v-else) {{ packListResp.company.address.postcode }} {{ packListResp.company.address.city }},
            div {{ packListResp.company.address.state }}, {{ packListResp.company.address.country }}.
          div.p2.primary500--text {{ packListResp.company.phone }}

</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'PackingSlips',
  props: ['pid'],
  data: () => ({
    isFetching: false,
    companyId: '',
    otk: '',
    packListResp: []
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    isPrinting () {
      if (this.$route.path.includes('print-packing-slips')) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.isPrinting) {
      const data = JSON.parse(atob(this.pid))
      this.companyId = data.company_id
      this.otk = data.key
      this.fetchPackList(data.leadPids.join())
    } else {
      this.companyId = this.company.name
      this.companyName = this.company.name
      this.companyAddress = this.company.address
      this.companyPhone = this.company.phone
      this.fetchLeads()
    }
  },
  methods: {
    fetchLead (pid) {
      this.$axios.get(`/leads/${pid}/`)
        .then((resp) => {
          this.leads.push(resp.data)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchPackList(leadPids) {
      this.isFetching = true
      let url = `/leads/pack_list?company=${this.companyId}&lead_ids=${leadPids}&key=${this.otk}`
      this.$axios.get(url)
        .then((response) => {
          this.packListResp = response.data
          this.isFetching = false
        })
        .catch(() => {})
    },
    clickPrint () {
      const data = {
        company_id: this.companyId,
        company_name: this.companyName,
        company_address: this.companyAddress,
        company_phone: this.companyPhone,
        leadPids: this.leads.map(m => { return m.pid})
      }
      const dataString = btoa(JSON.stringify(data))
      let printUrl = `https://pdf.yezza.io/?url=http://localhost:8080/print-packing-slips/${dataString}`
      if (this.$subdomain) {
        printUrl = `https://pdf.yezza.io/?url=${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/print-packing-slips/${dataString}`
      }
      printUrl += `&type=pdf&filename=packing-slips.pdf&waitUntil=networkidle0&printBackground=true&format=A4`
      if (this.$isMobile) {
        window.open(printUrl)
      } else {
        location.href = printUrl
      }
    }
  }
}
</script>

<style scoped>
.page-break {
  page-break-after: always;
}
</style>

<i18n>
{
  "en": {
    "order_id": "Order ID",
    "date_ordered": "Date ordered",
    "billing_address": "Billing address",
    "qty": "Qty",
    "thank_you_for_shopping": "Thank you for shopping with us!"
  },
  "id": {
    "order_id": "Order ID",
    "date_ordered": "Tanggal Order",
    "billing_address": "Alamat tagihan",
    "qty": "Qty",
    "thank_you_for_shopping": "Terima kasih berbelanja dengan kami!"
  }
}
</i18n>
